import { AbstractApiService } from '../AbstractApiService'

export abstract class AbstractRetailApi extends AbstractApiService {
  abstract version: number

  protected getDsn(): string {
    return import.meta.env.VITE_VUE_API_BASE_URL.replace('{version}', `v${this.version}`)
  }
}
